import request from '@/utils/request'

export function fetchCountryCodes() {
  return request({
    url: '/v1/common/country-codes',
    method: 'get'
  })
}